import {lazy} from 'react';

export const MultimediaVideoLazy = lazy(() => import(/* webpackChunkName: "multimediaVideo" */ '.'));
